export default {
  header: {
    title: 'Paiement',
    subTitle: 'Siège {{seat}}', 
  },
  

  tabs: {
    creditCard: 'Carte de crédit',
    opusCard: 'Carte OPUS',
    cashOnBoard: 'Perception (Argent comptant)',
    correspondance: 'Correspondance',
    free: 'Free',
    opusCardMensuel: 'Carte OPUS - Mensuel',
    opusCardPassage: 'Carte OPUS - Passage',
    cpoPassage: 'Carte a puce occasionnelle (CPO) - Passage',
    freeZeroToEleven: 'Gratuit (0-11 Ans)',
  },

  creditCard: {
    form: {
      fields: {
        cardNumber: {
          label: 'Numéro de carte',
          required: 'Card number is required',
        },
        cardHolderName: {
          label: 'Nom sur la carte',
          required: 'Cardholder name is required',
        },
        cardMonth: {
          label: 'Mois',
          required: 'Mois est requis',
        },
        cardYear: {
          label: 'Année',
          required: 'Année est requise',
        },
        cvv: {
          label: 'CVV',
          required: 'Numéro à 3 chiffre est requis',
        },
      },
    },
  },

  opusCard: {
    form: {
      fields: {
        cardNumber: {
          label: 'Numéro de carte OPUS',
          required: 'Numéro de carte OPUS est requis',
          min: 'OpusCardNumber doit comporter au moins {{length}} caractères'
        },
      },
    },
  },

  cashOnBoard: {
    rateType: {
      ordinary: 'Ordinaire',
      free0_5: 'Gratuit (0-5 Ans)',
      free6_11: 'Gratuit (6-11 Ans)',
      free0_11: 'Gratuit (0-11 Ans)',
    },
    form: {
      fields: {
        rateType: {
          label: 'Type de tarif',
          required: 'Type de tarif est requis',
        },
      },
    },
  },



};